const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default alphabet;
